module.exports = __webpack_public_path__ + "static/media/builtinv2-Krestiki 1.30a74b41.png";